$(function () {
  $(".keymenu").click(function () {
    $(this).next(".submenu").slideToggle();
    $(this).toggleClass("up");
  });
});
